document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        const host = document.querySelector('#app-embed');
        if (host) {
          const sheet = new CSSStyleSheet;
          sheet.replaceSync( `
            button._formSubmitButton_ed7ce_82.hiddenField {
                display: none;
            }

            .hiddenField {
                display: none;
            }

            ._inline_whyqz_45 ._formContainer_whyqz_30 {
                background: #494c4f;
                border-radius: 5px;
            }

            :host {
                --inline-container-max-width: 540px;
                --forms-heading-font: normal 600 24px Inter, Verdana, Geneva, Tahoma, sans-serif;
                --form-background-color: #ffffffbf;
                --button-border-radius: 50px;
            }

            input[type="radio"] {
                height: 13px;
                width: 13px;
            }

            ._horizontalLayout_nw6va_12 {
                grid-template-columns: 1fr 1fr;
            }

            form._formFieldset_16kdc_67 {
                gap: 25px;
            }

            section._formHeader_16kdc_19 {
                margin-top: 2rem;
            }

            .nextStepBtn {
                display: flex;
                justify-content: center;
                background: #ed1b24;
                padding: var(--button-padding);
                color: var(--button-text-color);
                border-radius: var(--button-border-radius);
                cursor: pointer;
                width: 140px;
            }

            .bullet-indicators {
                margin-top: 0;
                width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
            }

            .bullet {
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background-color: #ffffffbf;
                display: inline-block;
                margin-right: 10px;
            }

            .highlighted {
                background-color: #fff;
            }
            output{
                text-transform: uppercase;
            }
          `);
          host.shadowRoot.adoptedStyleSheets.push(sheet);

          const formContainer = host.shadowRoot.querySelector('._formContainer_whyqz_30');
          const form = host.shadowRoot.querySelector('form');
          const disclaimer = host.shadowRoot.querySelector('._formDisclaimer_ed7ce_38');
          const heading = host.shadowRoot.querySelector('._textHeading_2aowh_35');
          const checkbox = host.shadowRoot.querySelector('._radioField_nw6va_1');
          checkbox.click();
          // if (checkbox) {
          //     checkbox.checked = true;
          // }
          // checkbox.click();
          if (form && !form.hasAttribute('data-next-button-added')) {
            const childrens = Array.from(form.childNodes);

            childrens.forEach((children, index) => {
              index > 4 ? children.classList.add('hiddenField', 'secondStepField') : children.classList.add('firstStepField');
            });

            const backButton = document.createElement('a');
            backButton.classList.add('backBtn');
            backButton.textContent = '< Back';
            backButton.href = '/account/register';

            // formContainer.appendChild(backButton);

            const bullets = document.createElement('div');
            bullets.classList.add('bullet-indicators');

            const step1Bullet = document.createElement('span');
            step1Bullet.classList.add('bullet', 'highlighted');

            const step2Bullet = document.createElement('span');
            step2Bullet.classList.add('bullet');

            bullets.appendChild(step1Bullet);
            bullets.appendChild(step2Bullet);
            console.log(disclaimer);

            heading?.insertAdjacentElement('beforebegin', bullets);

            disclaimer?.classList.add('hiddenField');

            const nextButton = document.createElement('div');
            nextButton.classList.add('nextStepBtn');
            nextButton.textContent = 'Next Step >';
            
            nextButton.addEventListener('click', () => {
              const firstInputs = childrens.filter((_, index) => index <= 3).map(child => child.querySelector('input')).filter(Boolean);
              const allInputsFilled = firstInputs.every(input => input.value.trim() !== '');

              if (allInputsFilled) {
                childrens.forEach((children, index) => {
                  index <= 4 ? children.classList.add('hiddenField') : children.classList.remove('hiddenField');
                });
  
                disclaimer.classList.remove('hiddenField');
                nextButton.style.display = 'none';
  
                step1Bullet.classList.remove('highlighted');
                step2Bullet.classList.add('highlighted');
              }else{
                host.shadowRoot.querySelectorAll('.firstStepField').forEach(function (e) {
                  const input = e.querySelector('input'); // Get the input element
                  if (input) {
                    const value = input.value.trim(); // Trim whitespace
                    const type = input.type; // Get input type
                    let isValid = false;

                    // Validation based on input type
                    switch (type) {
                      case 'text':
                        isValid = value.length > 0; // Text should not be empty
                        if (input.getAttribute('id') === "email") {
                          isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value); // Simple email regex
                        }
                        break;
                      case 'email':
                        isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value); // Simple email regex
                        break;
                      case 'number':
                        isValid = !isNaN(value) && value !== ''; // Ensure it's a valid number
                        break;
                      case 'url':
                        isValid = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/.test(value); // URL regex
                        break;
                      case 'tel':
                        isValid = /^[0-9+\-()\s]*$/.test(value); // Phone number validation
                        break;
                      case 'date':
                        isValid = !isNaN(Date.parse(value)); // Validate date
                        break;
                      case 'checkbox':
                      case 'radio':
                        isValid = input.checked; // For checkboxes and radios, check if selected
                        break;
                      default:
                        isValid = value.length > 0; // Default: Non-empty value
                    }

                    // Log result and handle error messages
                    const closestDiv = input.closest('div');
                    const existingError = closestDiv.querySelector('._formError_1ydxd_20');
                    if (isValid) {
                      console.log(`Valid input for type "${type}":`, value);
                      // Remove any existing error message
                      if (existingError) {
                        existingError.remove();
                      }
                    } else {
                      console.log(`Invalid input for type "${type}":`, value || '(empty)');
                      // Add an error message if it doesn't already exist
                      if (!existingError) {
                        const errorMessage = document.createElement('output');
                        errorMessage.setAttribute('role', 'alert');
                        errorMessage.className = '_formError_1ydxd_20';
                        var input_name = input.getAttribute('id').split('_').join(' ').toLowerCase();
                        // console.log(result)
                        errorMessage.textContent = `${input_name} is invalid`;
                        closestDiv.appendChild(errorMessage);
                      }
                    }
                  }
                });
              }
            });
  
            form.appendChild(nextButton);
            form.setAttribute('data-next-button-added', 'true');
            observer.disconnect();
          }
        }
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});